import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import "./navbar.css";

const Navication = () => {
  return (
    <Navbar
        expand="lg"
        className="nav-custom-navbar"
        sticky="top"
        collapseOnSelect
        >
        <Container>

            {/* Logo */}

            <Navbar.Brand href="/" className="nav-logo">
            <i className="bi bi-back"></i>
            <span>Topic</span>
            </Navbar.Brand>

            {/* Mobile Profile */}

            <div className="nav-mobile-profile d-lg-none ms-auto me-3">
            <a href="#top" className="nav-navbar-icon">
                <i className="bi bi-person"></i>
            </a>
            </div>

            {/* Toggle */}

            <Navbar.Toggle aria-controls="navbar-nav" />

            <Navbar.Collapse id="navbar-nav">

            <Nav className="mx-auto">

                <Nav.Link href="#section_1">
                Home
                </Nav.Link>

                <Nav.Link href="#section_2">
                For Students
                </Nav.Link>

                <Nav.Link href="#section_3">
                For Business
                </Nav.Link>

                <Nav.Link href="#section_4">
                Contact
                </Nav.Link>

                <NavDropdown
                title="Pages"
                id="pages-dropdown"
                >
                <NavDropdown.Item href="#">
                    Topics Listing
                </NavDropdown.Item>

                <NavDropdown.Item href="#">
                    Contact Form
                </NavDropdown.Item>
                </NavDropdown>

            </Nav>

            {/* Desktop Profile */}

            <div className="nav-desktop-profile d-none d-lg-block">
                <a href="#top" className="nav-navbar-icon">
                <i className="bi bi-person"></i>
                </a>
            </div>

            </Navbar.Collapse>

        </Container>
        </Navbar>
  );
};


export default Navication;